module.exports = __webpack_public_path__ + "08_medium_black.a4ec6936.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/08_medium_black.png
// module id = NTv6
// module chunks = 0